export default {
  categories: {
    none: 'no-category',
    googleAnalyticsTracking: 'google-analytics-tracking',
    gasv2Tracking: 'gas-v2-tracking',
  },
  actions: {
    none: 'no-action',
    inferredNameMatch: 'inferred-name-match',
    inferredNameMismatch: 'inferred-name-mismatch',
    noNameProvided: 'no-name-provided',
    trackingFailure: 'tracking-failure',
  },
  labels: {
    none: 'no-label',
  },
  reasons: {
    trackingNotLoaded: 'tracking-not-loaded',
  },
  urls: {
    gasv2Url: 'https://mgas.prod.public.atl-paas.net/v1/event',
  },
};
